import React, { useState } from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import VisionSection from '../components/VisionSection';
import PartnersSection from '../components/PartnersSection';
import ContactSection from '../components/ContactSection';
import ContactPopup from '../components/ContactPopup';

function Home() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <main>
      <Hero onContactClick={() => setIsContactOpen(true)} />
      <AboutSection />
      <VisionSection />
      <PartnersSection />
      <ContactSection onContactClick={() => setIsContactOpen(true)} />
      <ContactPopup isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </main>
  );
}

export default Home;